export const version = '2.2.6'
